import debounce from 'lodash.debounce';
import { mapState } from 'vuex';
import { FILTERS_SEARCHING } from '@/constants/filtersModelNames';

export default {
    data: () => ({
        searchCountries: null,
        isCountriesLoading: false,
        debounceGetCountries: null,
        countriesPaginationPage: 1
    }),
    computed: {
        ...mapState('generalConfigurations', [
            'totalCountriesAmount',
            'countries'
        ])
    },
    watch: {
        searchCountries: {
            handler (val) {
                if (!val || this.isCountriesLoading) {
                    return;
                }

                this.debounceGetCountries(val);
            }
        }
    },
    methods: {
        getCountries (additionalParams = null) {
            this.isCountriesLoading = true;

            let params = {};

            if (typeof additionalParams === 'string') {
                params['filter[search][match]'] = additionalParams;
            } else if (typeof additionalParams === 'object') {
                params = { ...additionalParams };
            }

            this.$store.dispatch('generalConfigurations/getCountries', params)
                .then(() => {
                    this.countriesPaginationPage = 1;
                })
                .finally(() => {
                    this.isCountriesLoading = false;
                });
        },
        getCountriesLazyLoading (additionalParams = null) {
            if (this.totalCountriesAmount > this.countries.length) {
                this.isCountriesLoading = true;

                this.countriesPaginationPage += 1;

                let params = {};

                if (typeof additionalParams === 'object') {
                    params = { ...additionalParams };
                }

                params['page[number]'] = this.countriesPaginationPage;

                const _name = this.searchCountries || this.filtersSearching?.[FILTERS_SEARCHING.COUNTRY];

                if (_name) {
                    params['filter[search]'] = _name;
                }

                this.$store.dispatch('generalConfigurations/getCountriesLazyLoading', params)
                    .finally(() => {
                        this.isCountriesLoading = false;
                    });
            }
        }
    },
    created () {
        this.debounceGetCountries = debounce(this.getCountries, 1000);
    }
};
